export enum UserRole {
    USER = 'User',
    ADMIN = 'Admin',
}
